import { render, staticRenderFns } from "./LssaDetails.vue?vue&type=template&id=34e57966&"
import script from "./LssaDetails.vue?vue&type=script&lang=js&"
export * from "./LssaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports